var React = require('react');

function WineBottle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M179.21 423.29L88.7 332.78l122-122 90.51 90.51z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M507.3 72.57L439.42 4.69a16 16 0 0 0-22.63 0l-22.63 22.63a16 16 0 0 0 0 22.63l-76.67 76.67a127.91 127.91 0 0 0-140.37 27.23L18.74 312.23a64 64 0 0 0 0 90.51l90.51 90.51a64 64 0 0 0 90.51 0l158.39-158.39a127.91 127.91 0 0 0 27.23-140.37l76.67-76.67a16 16 0 0 0 22.63 0l22.63-22.63a16 16 0 0 0-.01-22.62zM179.21 423.29L88.7 332.78l122-122 90.51 90.51z","className":"fa-primary","key":2})]);
}

WineBottle.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = WineBottle;

WineBottle.default = WineBottle;
